import React from 'react';
import PropTypes from 'prop-types';

import flow from 'lodash/flow';

import {
  Button,
  ButtonRow,
  Callout,
  FormLayout,
  Heading,
  HorizontalRule,
  Link,
  ListItem,
  Paragraph,
  Section,
  UnorderedList,
  withTrackPage,
  Panel,
} from '@piggybank/core';

import {
  Form,
} from '@piggybank/form';

import CreditInformationPanel from '~/components/CreditInformationPanel';
import LoanOptions from '~/components/LoanOptions';
import TopUpOhcCreditInformationPanel from '~/components/TopUpOhcCreditInformationPanel';

import { getHeaderKey, isButtonVisible, NLS, setPageTitle } from './payrollReviewFunctions';
import { simpleKronerVisible, topUpOhcVisible } from '~/genericFunctions';

import { withAppContext } from '~/AppContext';
import { SIMPLE_KRONER } from '~/constants/offerIds';

import getEnvironment from '~/lib/environment';
const environment = getEnvironment();
const PayrollReview = ({ data }) => {

  let heading = NLS`${getHeaderKey(data.displayData.globalData.offerId)}`;
  let offerIdQuery= data.displayData.globalData.offerId;
  return (
    <FormLayout>
      <Section>
        <Heading level={1}>{heading}</Heading>
        { (offerIdQuery=== SIMPLE_KRONER.Pasivos_CP_Mob || offerIdQuery=== SIMPLE_KRONER.Pasivos_AN_Mob) &&
           <Panel>{NLS`It allows you to pay debts you have in other financial institutions and continue with a good credit history.`}</Panel>
        }
        <HorizontalRule />
      </Section>
      <Form initialValues={{ loanAmountIndex: 0 }} onSubmit={setPageTitle(heading)}>
        {({ values }) => (
          <div>
            { (simpleKronerVisible(data.displayData.globalData.type)) &&
              <LoanOptions />
            }
            <Section>
              { simpleKronerVisible(data.displayData.globalData.type) &&
                <CreditInformationPanel index={values.loanAmountIndex} />
              }
              { topUpOhcVisible(data.displayData.globalData.type) &&
                <TopUpOhcCreditInformationPanel />
              }
            </Section>

            <Section>
              <Heading accentBar level={2}>
                {NLS`Terms and Conditions`}
              </Heading>

              <Callout type="information">
                <Paragraph marginBottom={0}>
                  {NLS`Important information`}
                </Paragraph>
              </Callout>

              <UnorderedList>
                <ListItem>
                  {`${NLS`Check requirements, terms, contract conditions and commissions in`} `}<Link href={'https://www.hsbc.com.mx/creditos/personales/'}>www.hsbc.com.mx/creditos/personales</Link>
                </ListItem>
                <ListItem>{NLS`CONDUSEF RECA Registration Numbers`}</ListItem>
                <ListItem>{NLS`I authorize periodic charges to be made to my account under the concept of direct debit for the payment of this credit.`}</ListItem>
                { (offerIdQuery===SIMPLE_KRONER.Pasivos_CP_Mob || offerIdQuery===SIMPLE_KRONER.Pasivos_AN_Mob) &&
                 <ListItem>{NLS`By requesting this credit at HSBC México S.A., Institución de Banca Múltiple, Grupo Financiero HSBC and, if applicable, I agree to pay the liabilities of the debts that I have to date with other financial institution(s). ). I recognize that by making payment of said debt(s), it helps me maintain a healthy level of my finances without affecting my credit history.`}</ListItem>
                }
              </UnorderedList>
              <HorizontalRule hiddenOnSmallViewport />

              <ButtonRow>
                <Button id={data.displayData.globalData.offerId}>{NLS`Accept`}</Button>
                {isButtonVisible(data.displayData.globalData.ismobile) &&
                  <Button elementType="a" href={environment.bankingDashboardUrl} secondary target="_self">{NLS`Back`}</Button>
                }
              </ButtonRow>
            </Section>
          </div>
        )}
      </Form>
    </FormLayout>
  );};

PayrollReview.propTypes = {
  data: PropTypes.shape({
    displayData: PropTypes.shape({
      globalData: PropTypes.shape({
        offerId: PropTypes.string,
        type: PropTypes.string,
      }),
    }),
  }),
};

export default flow(
  withAppContext(),
  withTrackPage('loanReview', 'component')
)(PayrollReview);
